export const nameSlicer = (name: string) => {
  if (name.length < 25) {
    return name;
  } else {
    return `${name.slice(0, 10)}...`;
  }
};
